module.exports = __webpack_public_path__ + "static/SINAI-d32206e25ae59ca52dfae2bc7e49c4fc.jpg";